import React from 'react'
import './Engagement.css'

function Engagement() {
    const EngagementData = [
        {
            Number: "1",
            Head: "Scrum",
            Desc: "It's an iterative development process suitable for large and complex  projects having changing requirements. It's a cyclic process with  overlapping sprints."
        },
        {
            Number: "2",
            Head: "Waterfall",
            Desc: "It's a linear approach to software development process. It's best suited  for small projects since it measures the progress of entire scope in  advance."
        },
        {
            Number: "3",
            Head: "Kanban",
            Desc: "Kanban streamlines the project lifecycle and makes team collaboration effective by making consistent improvements and easing changes in the management."
        }
    ]
    
  return (
    <section className='engage-sec'>
        <div className='container'>
            <h3>Engagement methodologies that we offer</h3>
            <ul>
                {
                  EngagementData.map((Engagement, index)=>(
                    <li key={index}>
                        <h4><span>#{Engagement.Number}</span> {Engagement.Head}</h4>
                        <p>{Engagement.Desc}</p>
                    </li>   
                  ))  
                }
            </ul>
        </div>
    </section>
  )
}

export default Engagement
